<template>
  <div>
    <general-table
      :api-url="apiUrl"
      :edit-component="editComponent"
      :add-component-name="addComponentName"
      :delete-content="true"
      :block-content="false"
      :edit-content="true"
      :view-content="false"
      :add-type="addType"
      :columns="columns"
      :type="type"
    >
      <template #cell(documents)="data">
        <ul class="py-1 px-1 list-unstyled d-flex flex-column align-items-start">
          <li
            v-for="item in data.item.documents"
            :key="item.id"
            v-b-tooltip.hover
            variant="light"
            class="truncate-text-documentary-requirements"
            :title="item"
          >
            {{ item }}
          </li>
        </ul>
      </template>
    </general-table>
  </div>
</template>

<script>
import GeneralTable from '@/components/general-table/GeneralTable.vue'

export default {
  components: { GeneralTable },
  data() {
    return {
      APIURL: '/halal/documentary-requirements',
      addType: 'Add Halal Documentary Requirements',
      addComponentName: 'add-halal-documentary-requirements',
      editComponent: 'edit-halal-documentary-requirements',
      viewContent: false,
      expandedIds: [],
      type: 'page',
      partners: [],
      filter: {},
      types: '',
      columns: [
        { key: 'product_category.name', label: 'standard type' },
        { key: 'documents', label: 'documents' },
        { key: 'actions' },
      ],
    }
  },

  computed: {
    apiUrl() {
      let base = '/halal/documentary-requirements?'

      if (!Object.values(this.filter)?.length) {
        return base.slice(0, -1)
      }

      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(this.filter)) {
        if (key && value) {
          base += `${key}=${value}&`
        }
      }
      return base.slice(0, -1)
    },
  },
  // mounted() {
  //   console.log('Count in mounted:', this.role)
  // },

  methods: {
    filterTypes(type) {
      const filteredType = this.status.filter(item => item.text !== type)
      this.types = filteredType
    },
  },
}
</script>

<style>
.truncate-text-documentary-requirements {
  max-width: 900px;    /* adjust width as you want */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
</style>
